import React from 'react'
import {Redirect} from 'react-router-dom'
import {isEmpty} from 'lodash'

import errors from '../../lib/errors.js'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'

import {ServiceCard} from './ServiceCard'
import ServiceNotFound from './ServiceNotFound'

import Resource from '../../stores/resource'
const ServiceStore = Resource('services')

class ShowService extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      service: {},
      error: null,
      loading: true
    }
  }

  componentDidMount() {
    ServiceStore.find(this.props.match.params.id)
    .then((result) => this.setState({
      service: result.data,
      loading: false
    }))
    .catch((error) => this.setState({
      service: {},
      error: errors.unpack(error),
      loading: false
    }))
  }

  _redirectTo = (url) => {
    this.setState({redirect: url})
  }

  render() {
    const {
      redirect,
      loading,
      service,
    } = this.state

    if (redirect) return <Redirect push to={redirect}/>
    if (loading) return <LinearLoader />
    if (isEmpty(service)) return <ServiceNotFound/>

    return (
      <section>
        <header>
          <PageTitle>
            Service: <span className="mui--text-dark">{service.name}</span>
          </PageTitle>
        </header>
        <ServiceCard
          service={service}
          editCallback={() => this._redirectTo(`/services/${service.id}/edit`)}
        />
        <br/>
        <BackButton/>
      </section>
    )
  }
}

export default ShowService



// WEBPACK FOOTER //
// ./src/components/Services/ShowServicePage.jsx